import { render, staticRenderFns } from "./ContactUsDesktop.vue?vue&type=template&id=bb3dfdfe&scoped=true"
import script from "./ContactUsDesktop.vue?vue&type=script&lang=js"
export * from "./ContactUsDesktop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb3dfdfe",
  null
  
)

export default component.exports